module.exports = __webpack_public_path__ + "assets/816621c73e062d656fccd89089ed535d.mp3";